import { render, staticRenderFns } from "./SchoolFeeReport.vue?vue&type=template&id=083d987e&scoped=true"
import script from "./SchoolFeeReport.vue?vue&type=script&lang=js"
export * from "./SchoolFeeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083d987e",
  null
  
)

export default component.exports